export class LoginRequest {
  email: string;
  senha: string;
  tipoSaas: number;
}
